<template>
  <div class="d-flex justify-start">
    <div
      v-if="donneePerso"
      class="d-flex"
    >
      <span
        class="dot-secondary align-self-center mr-2"
        :style="styleDotColorPrimaire"
      />
      <span
        class="texte texte-gris-fonce align-self-center"
      >
        {{ donneePerso.libelle }}
      </span>
    </div>
    <div
      v-if="donneeGroupe"
      class="d-flex ml-6"
    >
      <span
        class="dot-primary align-self-center mr-2"
        :style="styleDotColorSecondaire"
      />
      <span
        class="texte texte-gris-fonce align-self-center"
      >
        {{ donneeGroupe.libelle }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseComparaisonLegende',
  props: {
    donneePerso: {
      type: Object,
      default: null
    },
    donneeGroupe: {
      type: Object,
      default: null
    },
    couleurPrimaire: {
      type: String,
      default: '#DBBD00'
    },
    couleurSecondaire: {
      type: String,
      default: null
    }
  },
  computed: {
    styleDotColorPrimaire () {
      return 'background-color: ' + this.couleurPrimaire 
    },
     styleDotColorSecondaire () {
      return 'background-color: ' + this.couleurSecondaire 
    }
  }
}
</script>
<style lang="scss">
.dot-secondary {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
}

.dot-primary {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
}

</style>